import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cd1461b2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=cd1461b2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd1461b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd1461b2')) {
      api.createRecord('cd1461b2', component.options)
    } else {
      api.reload('cd1461b2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=cd1461b2&scoped=true", function () {
      api.rerender('cd1461b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/head/index.vue"
export default component.exports